<template>
  <div class="Marm">
    <div v-if="$route.path === '/devicemanagement/mechanicalarm'" class="right">
      <div class="operation">
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          class="table-fixed"
          :data="tableData"
          stripe
          @sort-change='sortChange'
          :default-sort="defaultSort"
          ref="table"
          style="width: auto;"
          v-loading="loading"
          height="100%">
          <el-table-column
            prop="description"
            :label="$t('LanguageLib.Equipment_Number')"
            sortable="custom"
            min-width="120">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span slot="content" type="description">{{scope.row.description}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="description">{{scope.row.description}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceType"
            :label="$t('LanguageLib.Device_Type')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="deviceType">{{scope.row.deviceType}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="deviceType">{{scope.row.deviceType}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="serialNumber"
            :label="$t('LanguageLib.Device_SN')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="serialNumber">{{scope.row.serialNumber}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="serialNumber">{{scope.row.serialNumber}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="privateIp"
            :label="$t('LanguageLib.Intranet_IP')"
            sortable="custom"
            min-width="120">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="privateIp">{{scope.row.privateIp}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="privateIp">{{scope.row.privateIp}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="brand"
            :label="$t('LanguageLib.ARM_BRAND')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="brand">{{scope.row.brand}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="brand">{{scope.row.brand}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="modelNumber"
            :label="$t('LanguageLib.MODEL')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="modelNumber">{{scope.row.modelNumber}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="modelNumber">{{scope.row.modelNumber}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="location"
            :label="$t('LanguageLib.Installation_POSITION')"
            sortable="custom"
            min-width="200">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="location">{{scope.row.location}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="location">{{scope.row.location}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="owner"
            :label="$t('LanguageLib.CUSTOMER')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="owner">{{scope.row.owner}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="owner">{{scope.row.owner}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="publicIp"
            :label="$t('LanguageLib.INTERNET_IP')"
            sortable="custom"
            min-width="120">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="publicIp">{{scope.row.publicIp}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="publicIp">{{scope.row.publicIp}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            :label="$t('LanguageLib.STATE')"
            sortable="custom"
            min-width="70">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="status">{{$commonfun.ArmStatus(scope.row.status)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="status"><span :style="scope.row.status === 'OFFLINE' ? 'display:inline-block;width:10px;height:10px;background:red;border-radius:50%;margin-right:5px;' : 'display:inline-block;width:10px;height:10px;background:green;border-radius:50%;margin-right:5px;'"></span>{{$commonfun.ArmStatus(scope.row.status)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="dateCreated"
            :label="$t('LanguageLib.LAST_USE_TIME')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start">
                <span slot="content" type="dateCreated">{{$commonfun.formatDate(scope.row.dateCreated, '3')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="dateCreated">{{$commonfun.formatDate(scope.row.dateCreated, '3')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="70">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editMechanicalarm(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <router-view v-if="$route.path !== '/devicemanagement/mechanicalarm'"></router-view>
  </div>
</template>

<script>
import devicemanagementApi from '../../api/devicemanagement'
export default {
  name: 'mechanicalarm',
  props: {
    msg: String
  },
  data () {
    return {
      seen: false, // 鼠标移入是否显示背景色
      current: 0, // 当前要显示背景色的数据
      loading: true, // loading状态
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      getEquipmentDataListFun: (pageIndex, pageSize, searchVal, sort, sortOrder) => {
        this.loading = true
        devicemanagementApi.GetEquipmentList('get', '/api/v4/devices', { pi: pageIndex, pz: pageSize, deviceType: 'MechanicalClaw', search: searchVal, sequence: sort, order: sortOrder }, 'deviceApi')
          .then(res => {
            this.$commonfun.console.log(res)
            this.tableData = res.data.data
            this.pageTotal = res.data.rowCount
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      searchText: '', // 列表搜索关键词
      currentPage: 1, // 默认显示第1页数据
      pageSize: 20, // 默认每页显示20条数据
      sort: '', // 排序字段
      sortOrder: '', // 排序方式逆序：desc正序asc
      defaultSort: { prop: 'dateCreated', order: 'descending' }, // 默认排序
      prevSort: 'descending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'dateCreated', // 记录前一次的prop值
      updataRouteQuery: () => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.searchText = this.$commonfun.encodeUrl(this.searchText)
        newQuery.sort = this.sort
        newQuery.sortOrder = this.sortOrder
        newQuery.NoRefresh = true
        this.$router.push({ path, query: newQuery })
      }
    }
  },
  created () {
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.domainId = this.$route.query.checkDomainId
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort
      this.sortOrder = this.$route.query.sortOrder
      if (this.sortOrder === 'asc') {
        this.defaultSort = { prop: this.sort, order: 'ascending' }
        this.prevSort = 'ascending'
      } else {
        this.defaultSort = { prop: this.sort, order: 'descending' }
        this.prevSort = 'descending'
      }
      this.prevProp = this.sort
    }
    this.getEquipmentDataListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
  },
  methods: {
    // 列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.sortOrder = 'asc'
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.sortOrder = 'desc'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.sortOrder = column.column.order === 'descending' ? 'desc' : 'asc'
      }
      this.sort = column.prop
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getEquipmentDataListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getEquipmentDataListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.domainId, this.searchText, this.sort, this.sortOrder, this.checkedStoreTypeDataOld, this.checkedModeOperationDataOld, this.checkedBrandDataOld)
    },
    // 列表模糊搜索
    searchDomainList () {
      this.updataRouteQuery()
      this.currentPage = 1
      this.getEquipmentDataListFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
    },
    // 编辑店铺
    editMechanicalarm (data, index, tableData) {
      this.$router.push('/devicemanagement/mechanicalarm/updatamechanicalarm?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&type=edit&data=' + this.$commonfun.encodeUrl(JSON.stringify(data)))
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.Marm{
  width:100%;
  height: 100%;
}
.Marm .left{
  background: #fff;
  width: 20%;
  float:left;
  height: 100%;
  border-right: 1px solid #f2f2f2;
  .treeBox{
    height: calc( 100% - 50px );
    overflow: auto;
    width: 100%;
  }
  .fifter{
    padding: 10px 0 10px 6%;
    line-height: 30px;
   .el-input{
      width: 60%;
    }
    .el-button--text{
      margin-left: 2.5%;
      padding: 2% 0;
      width: 20%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.Marm .right{
  width: 100%;
  height: 100%;
  .operation{
    background: #fff;
    height: 30px;
    padding: 10px 0 10px 20px;
    border-bottom: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
    .operationBtn{
      width: auto;
      display: inline-block;
      float:left;
      position: relative;
      .el-button{
        height: 30px;
        padding: 7px 20px;
      }
      .BatchSetting{
        background: #fff;
        color: #666666;
        position:absolute;
        left: 0;
        top: 30px;
        width:100px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
        }
      }
      .exportType{
        background: #fff;
        color: #666666;
        position:absolute;
        right: 0;
        top: 30px;
        min-width:100px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
        }
      }
    }
    .operationSearch{
      float:right;
      padding-right: 51px;
      position: relative;
      .shaixuan{
        color: #999999;
        height: 15px;
        width: 15px;
        position: relative;
        top: 2px;
        margin-left: 10px;
        margin-right: 10px;
        font-weight: 600;
      }
      .shaixuan1{
        color: #3BC6B9;
      }
      .el-input{
        width: 160px;
        .el-input__inner{
          height: 30px;
          line-height: 30px;
          border-radius: 20px;
        }
      }
      .el-icon-search{
        line-height: 30px;
      }
    }
  }
  .tableParent{
    height: calc( 100% - 98px );
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
  }
}
.Marm .drawerTitle{
  height:25px;
  font-size:18px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:25px;
  margin-bottom: 20px;
}
.Marm .drawerText{
  height:16px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:16px;
  margin-bottom: 5px;
}
.cell{
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
.el-button--default{
  border:1px solid #3BC6B9;
  color:#3BC6B9;
}
.el-button--primary{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
  margin-left: 10px;
}
.el-button--primary:hover{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
}
/*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #3BC6B9 !important;
  border-color: #3BC6B9 !important;
}*/
// 对于树组件配置特有的css
.el-tree-node>.el-tree-node__children{
  overflow: unset;
}
.el-tree-node__content{
  height: 48px;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  background-color: #F6F6F6
}
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
//   color: #3BC6B9 !important;
// }
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
//   color: #3BC6B9 !important;
// }
// 更改表格的滚动条样式
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
// 抽屉组件样式修改
.el-drawer.rtl{
  outline: none;
}
.el-drawer__wrapper{
  top: 172px;
  bottom: 18px;
/*  right: 20px;*/
}
section.el-drawer__body{
  padding: 20px;
  .el-input{
    margin-bottom: 15px;
  }
}
.el-drawer__container{
  outline: none;
}
.colorG{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(59,198,185,1);
  line-height:20px;
}
.el-table .descending .sort-caret.descending{
}
.el-table .ascending .sort-caret.ascending{
  border-bottom-color: #3BC6B9;
}
.el-pager li.active{
  color: #3BC6B9;
}
.el-table__fixed-body-wrapper .el-table__body{
    padding-bottom: 10px;
}
.filterContent{
  height: calc(100% - 154px);
  overflow: hidden;
  overflow-y: auto;
}
.filterContent::-webkit-scrollbar{
    width: 10px;
    height: 10px;
}
.filterContent::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.filterContent::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
.el-table-column--selection{
  text-align: center !important;
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #000;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}
</style>
